import { useState, useEffect } from "react";

export interface UseTrendsViewStateReturn {
  showCauses: boolean;
  setShowCauses: (show: boolean) => void;
  selectedView: "PERSONAL" | "TEAM";
  setSelectedView: (view: "PERSONAL" | "TEAM") => void;
  selectedCauseView: "BALANCED" | "BURNOUT" | "GROWTH" | "OVERVIEW";
  setSelectedCauseView: (
    view: "BALANCED" | "BURNOUT" | "GROWTH" | "OVERVIEW"
  ) => void;
  selectedWeek: string;
  setSelectedWeek: (week: string) => void;
  insightsGranularity: "week" | "month";
  setInsightsGranularity: (g: "week" | "month") => void;
  selectedMonth: string;
  setSelectedMonth: (monthKey: string) => void;
}

export function useTrendsViewState(
  personalSelectedPeriod: string
): UseTrendsViewStateReturn {
  const [showCauses, setShowCauses] = useState(false);
  const [selectedView, setSelectedView] = useState<"PERSONAL" | "TEAM">(
    "PERSONAL"
  );
  const [selectedCauseView, setSelectedCauseView] = useState<
    "BALANCED" | "BURNOUT" | "GROWTH" | "OVERVIEW"
  >("OVERVIEW");
  const [selectedWeek, setSelectedWeek] = useState<string>("");
  const [insightsGranularity, setInsightsGranularity] = useState<
    "week" | "month"
  >("week");
  const [selectedMonth, setSelectedMonth] = useState<string>("");

  useEffect(() => {
    if (selectedView === "PERSONAL" && personalSelectedPeriod) {
      setSelectedWeek("");
    }
  }, [personalSelectedPeriod, selectedView]);

  return {
    showCauses,
    setShowCauses,
    selectedView,
    setSelectedView,
    selectedCauseView,
    setSelectedCauseView,
    selectedWeek,
    setSelectedWeek,
    insightsGranularity,
    setInsightsGranularity,
    selectedMonth,
    setSelectedMonth,
  };
}
